import { graphql } from "gql";

const EDIT_MESSAGE_MUTATION = graphql(`
  mutation EditMessage($id: ID!, $input: EditMessageInput!) {
    editMessage(id: $id, input: $input) {
      ...Message
    }
  }
`);

export default EDIT_MESSAGE_MUTATION;
